import {PATH_STATISTIC} from "@constants/navigate";
import {IBreadcrumbItem} from "@ui/breadcrumbCustom/types";

export const BREADCRUMBS_STATISTIC: IBreadcrumbItem[] = [
    {
        label: 'base.statistic', path: PATH_STATISTIC
    },
]